export default __webpack_public_path__ + "static/media/6.ebc78ca0.jpg";